import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Row, Col } from 'reactstrap'
import { ButtonLink } from '../../common/Links'
import theme from '../../theme'
import { ContainerLg, H1, Lead } from '../../GlobalStylesNew'
import gtmEvent from '../../../utils/gtm'

const fadeIn = keyframes`
  0% {
    opacity: 0;
    -webkit-filter: blur(50px);
    -moz-filter: blur(50px);
    -o-filter: blur(50px);
    -ms-filter: blur(50px);
  }
  50% {
    opacity:1;
  }
  100% {
    opacity:1;
    -webkit-filter: blur(0px);
    -moz-filter: blur(0px);
    -o-filter: blur(0px);
    -ms-filter: blur(0px);
  }
`

export const CustomMainBgImage = styled.div`
  background: #a3ae86 !important;
  background-repeat: no-repeat;
  background-position: 50% 0% !important;
  background-size: 100%;
  background-size: cover;
  text-align: left;
  align-items: ${p => p.position};
  justify-content: center;
  height: ${p => p.height || 400}px;
  max-height: 600px;
  display: flex;
  overflow: hidden;
  position: relative;
  @media (min-width: 768px) {
    padding: 0;
    max-height: 700px;
  }
  @media (min-width: 1024px) {
    padding: 0;
    max-height: 90vh;
  }
  @media (min-width: 1200px) {
    max-height: 90vh;
  }
`

export const Heading = styled(H1)`
  margin-top: 60px;
  margin-bottom: 20px;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1;
  text-align: left;
  text-shadow: none;
  @media (min-width: 768px) {
    margin-top: 0px;
    margin-bottom: 40px;
  }
`

export const BackgroundImageWrapper = styled.div`
  text-align: left;
  position: absolute;
  top: -60px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  min-height: 820px;
  min-width: 1440px;
  width: 100%;
  overflow: hidden;
  background: #a3ae86;
  -webkit-animation: ${fadeIn} 1.5s linear 0.5s;
  -moz-animation: ${fadeIn} 1.5s linear 0.5s;
  -ms-animation: ${fadeIn} 1.5s linear 0.5s;
  -o-animation: ${fadeIn} 1.5s linear 0.5s;
  animation: ${fadeIn} 1.5s linear 0.5s;
  @media (max-width: 768px) {
    height: 100%;
    width: auto;
  }
`

export const HeroButton = styled(ButtonLink)`
  margin-bottom: 50px;
  a {
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 600;
    text-shadow: 0px 0px 0 rgba(0, 0, 0, 0.5);
    @media screen and (max-width: 350px) {
      padding: 11px 36px;
    }
  }
`

export const HeroParagraph = styled(Lead)`
  text-align: left;
  margin-bottom: 28px;
  text-shadow: none;
  @media (min-width: 768px) {
    margin-bottom: 40px;
  }
`
export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  &:before {
    display: block;
    content: '';
    padding-top: 60.25%;
  }
  &:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgba(15, 16, 19, 0.33);
    z-index: 100;
  }
  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`
const Video = ({ src }) => (
  <iframe
    src={src}
    frameBorder='0'
    webkitallowfullscreen='true'
    mozallowfullscreen='true'
    allowFullScreen
    title='PGA Coach'
  />
)

const handleHeroButtonClick = () => {
  gtmEvent({
    event: 'index-page-click',
    indexPageCategory: 'hero-cta',
    indexPageLabel: 'get-started',
    indexPageAction: 'click-hero-cta'
  })
}

export const MainImageV2 = () => {
  return (
    <CustomMainBgImage height={820} position='center'>
      <BackgroundImageWrapper>
        <VideoWrapper>
          <Video src='https://player.vimeo.com/video/318557649?background=1&autoplay=1&loop=1&byline=0&title=0' />
        </VideoWrapper>
      </BackgroundImageWrapper>
      <ContainerLg>
        <Row>
          <Col xl={6} lg={7} md={11}>
            <Heading>A reimagined approach for the game’s best coaches</Heading>
            <HeroParagraph>
              With a better work-life balance that allows you to focus on
              coaching, PGA Coach has the tools to help you grow and manage your
              business, and the expert training designed to help you better
              engage, inspire and retain golfers.
            </HeroParagraph>
            <HeroButton
              url='https://my.pga.com/pga-coach'
              bgColor={theme.colors.gold}
              borderColor={theme.colors.gold}
              color={theme.colors.white}
              bgHoverColor={theme.colors.darkGold}
              borderHoverColor={theme.colors.darkGold}
              btnStyle='primary'
              padding='14px 32px'
              aria-label='Get Started Today'
              onClick={handleHeroButtonClick}
            >
              Get Started Today
            </HeroButton>
          </Col>
        </Row>
      </ContainerLg>
    </CustomMainBgImage>
  )
}

export default MainImageV2
